import React, { useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { approve, hopeKeys } from '@mummssoftware/utils/hope';
import { HopeContext } from '../Context/HopeWidgetContext';
import { SET_BATCH_MODE } from '../Context/constants';
import { StyledBatchButton } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

export const BatchApproveButton = () => {
  const {
    palette: { primary },
  } = useTheme() as any;
  const {
    dispatch,
    batchMode,
    batchHopeActionUpdate,
    selectedRows,
    showLoader,
  } = useContext(HopeContext);
  const isBatchApprove = batchMode === approve;
  const showButton = !batchMode || isBatchApprove;
  const enabled = showLoader
    ? false
    : !isBatchApprove ||
      (selectedRows !== null &&
        selectedRows.every(
          (row: any) =>
            !hopeKeys.find(
              (key: string) =>
                row[key].numerrors !== null && row[key].numerrors > 0,
            ),
        ));
  // styles defined here to override MUI css
  return (
    <>
      {showButton && (
        <StyledBatchButton
          style={{
            color: primary.contrastText,
            backgroundColor: enabled ? primary.main : 'grey',
            fontSize: '10px',
            height: '1.25em',
            fontWeight: 'bold',
            padding: '10px',
            margin: '5px',
          }}
          onClick={() => {
            if (isBatchApprove) {
              selectedRows &&
                selectedRows?.length > 0 &&
                batchHopeActionUpdate(selectedRows, approve);
            } else {
              dispatch({ type: SET_BATCH_MODE, payload: approve });
            }
          }}
          disabled={!enabled}
        >
          {batchMode ? `${defaults.approve}` : `${defaults.batchApprove}`}
        </StyledBatchButton>
      )}
    </>
  );
};
